import React, { useEffect, useState } from "react";
import { ArrowLeftStyle, ArrowRightStyle, Container, Info, MainImage, ModelButton, SubtitleItalo, Thumbnail, Thumbnails, TitleItalo, ToggleButtonItalo } from "../../Trajes/Negros/styles";
import { Footer, NavItem, NavMenu } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";

const ItaloSmk = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    const enviarWhatsApp = (modelo) => {
        const numero = "5213311407070";
        const mensaje = `Hola, me interesa el modelo *${modelo}*, que vi en su página. ¿Podrías darme información sobre disponibilidad y precio?`;
        const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

        window.open(url, "_blank");
    };

    
    const italoSmk = [
        "/img/Italo-smk-ligero.jpg",
        "/img/Italo-smkf.jpg",
        "/img/Italo-smkr.jpg",
        "/img/Italo-smkl.jpg",
        "/img/Italo-smkpr.jpg",
        "/img/Italo-smkb.jpg",
        "/img/Italo-smkbup.jpg",
        "/img/Italo-smkdl.jpg",
        "/img/Italo-smkup.jpg",
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
                                                
    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % italoSmk.length);
    };
                                                                    
    const prevImage = () => {
        setCurrentIndex((prev) => (prev -1 + italoSmk.length) % italoSmk.length);
    };
                                                                   
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
                                                                  
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };
                                                                  
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };
                                                                   
    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 50) nextImage();
        if (touchEnd - touchStart > 50) prevImage();
    };

    return (
        <>
            <ToggleButtonItalo collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? "✕" : "☰"}
            </ToggleButtonItalo>
            <NavMenu collapsed={collapsed}>
               <NavItem
                    onClick={() => navigate("/")}
                    active = {location.pathname === "/"}
               >
                   Inicio
               </NavItem>
                            
               <NavItem
                    active={location.pathname.startsWith("/trajes")}
                    onClick={() => navigate("/trajes")}
               >
                   Trajes
                </NavItem>
                            
                <NavItem
                    active = {location.pathname.startsWith("/smokings")}
                    onClick={() => navigate("/smokings")}
                >
                   Smokings
                </NavItem>
                            
                <NavItem
                    active = {location.pathname === "/togas"}
                    onClick={() => navigate("/togas")}
                >
                  Togas
                </NavItem>
                <NavItem>
                    <a
                        href="/catalogo-trajes"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Catálogo
                    </a>
                </NavItem>
                <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
            </NavMenu>
            <Container>
                <div style={{ position: 'relative'}}>
                    <ArrowLeftStyle onClick={prevImage}>
                        <HiArrowLongLeft size={20}/>
                    </ArrowLeftStyle>
                    <MainImage 
                        src={italoSmk[currentIndex]} 
                        alt="Italo-Smoking"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}    
                    />
                    <ArrowRightStyle onClick={nextImage}>
                        <HiArrowLongRight size={20}/>
                    </ArrowRightStyle>
                </div>
                <Thumbnails>
                    {italoSmk.map((img, index) => (
                        <Thumbnail 
                            key={index}
                            src={img}
                            alt="thumbnail"
                            onClick={() => setCurrentIndex(index)}
                            active = {currentIndex === index}
                        />
                    ))}
                </Thumbnails>
                <Info>
                    <TitleItalo>Italo smoking</TitleItalo>
                    <SubtitleItalo>
                        Ideal para quienes buscan un 
                        look de gala en momentos importantes.
                        Un smoking versátil que eleva tu 
                        presencia en cualquier evento especial.
                    </SubtitleItalo>
                    <ModelButton onClick={() => enviarWhatsApp("Italo smoking")}>Cotizar</ModelButton>
                </Info>
            </Container>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
        </>
    )
};

export default ItaloSmk;